import { HttpError } from '@/errors/HttpError';

/** BFF create timeout (CORE_MS_HASHTAG_CAMPAIGN_TIMEOUT). */
export const HASHTAG_CAMPAIGN_CREATE_TIMEOUT_MS = 45_000;

/** Create may succeed in Core while BFF returns 502/504 — recover via GET list. */
export function isRecoverableHashtagCreateError(err: unknown): boolean {
  if (err instanceof HttpError) {
    const status = err.response?.status ?? 0;
    return status === 0 || status === 502 || status === 504;
  }
  if (err instanceof Error) {
    const msg = err.message.toLowerCase();
    return msg.includes('timeout') || msg.includes('network error');
  }
  return false;
}
